(() => {
  const debounce = (fn, delay = 120) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  class TierProgressBar extends HTMLElement {
    static SECTION_ATTR = 'section-id';

    constructor() {
      super();
      this._observer = null;
      this._drawer = null;

      const d = debounce;
      this._onCartTouch = d(() => this.refresh(), 120);
      this._onChange = null;
      this._onClick = null;
    }

    connectedCallback() {
      this._drawer = this.closest('[data-cart-drawer]') || document.querySelector('[data-cart-drawer]') || null;

      ['cart:updated', 'cart:change', 'ajaxProduct:added'].forEach(evt => {
        document.addEventListener(evt, this._onCartTouch);
      });

      if (this._drawer) {
        this._onChange = (e) => {
          if (e.target && e.target.matches('input[name="updates[]"], input[name="quantity"]')) {
            this._onCartTouch();
          }
        };
        this._onClick = (e) => {
          if (e.target && e.target.closest('[data-cart-quantity-increase], [data-cart-quantity-decrease], [name="add"], button[name="plus"], button[name="minus"]')) {
            this._onCartTouch();
          }
        };
        this._drawer.addEventListener('change', this._onChange);
        this._drawer.addEventListener('click', this._onClick);

        this._observer = new MutationObserver(this._onCartTouch);
        this._observer.observe(this._drawer, { childList: true, subtree: true });
      }

      this.refresh();
    }

    disconnectedCallback() {
      ['cart:updated', 'cart:change', 'ajaxProduct:added'].forEach(evt => {
        document.removeEventListener(evt, this._onCartTouch);
      });

      if (this._drawer) {
        if (this._onChange) this._drawer.removeEventListener('change', this._onChange);
        if (this._onClick) this._drawer.removeEventListener('click', this._onClick);
      }

      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }

      this._onChange = null;
      this._onClick = null;
      this._drawer = null;
    }

    async refresh() {
      const sectionId = this.getAttribute(this.constructor.SECTION_ATTR) || 'tier-progress';
      const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

      try {
        const url = `${base}?sections=${encodeURIComponent(sectionId)}&_=${Date.now()}`;
        const res = await fetch(url, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin'
        });
        if (!res.ok) return;

        const json = await res.json();
        const html = json[sectionId];
        if (typeof html === 'string') {
          this.innerHTML = html;
        }
      } catch {}
    }
  }

  if (!customElements.get('tier-progress-bar')) {
    customElements.define('tier-progress-bar', TierProgressBar);
  }
})();